import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

const AlertWrapper = ({
  alertClassName = '',
  alertVariant = '',
  header = '',
  body = '',
  buttonText = '',
  onDismiss = () => {},
  buttonVariant = '',
}) => {

  return (
    <Alert className={alertClassName} variant={alertVariant}>
      <Alert.Heading>{header}</Alert.Heading>
      {body}
      <div className="d-flex justify-content-end">
        <Button variant={buttonVariant} onClick={onDismiss}>
          {buttonText}
        </Button>
      </div>
    </Alert>
  );
};

AlertWrapper.propTypes = {
  alertClassName: PropTypes.string,
  alertVariant: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.any,
  buttonText: PropTypes.string,
  onDismiss: PropTypes.any,
  buttonVariant: PropTypes.string,
};
export default AlertWrapper;
